import i18nextDefault, {i18n} from "i18next";

export function getFixedT(namespace?: string, i18next?: i18n) {
    if (!i18next) {
        i18next = i18nextDefault;
    }

    return i18next.getFixedT(i18next.language, namespace);
}
